const LAST_SEEN_KEY = "whatsnew:lastSeenId";
const CHANGELOG_URL = `${process.env.PUBLIC_URL || ""}/changelog.json`;

export const CHANGELOG_TYPE_META = {
  FEAT: { label: "Feature", className: "bg-blue-100 text-blue-800" },
  FIX: { label: "Fix", className: "bg-red-100 text-red-800" },
  REFACTOR: { label: "Improvement", className: "bg-purple-100 text-purple-800" },
  CHORE: { label: "Chore", className: "bg-app-surface-muted text-app-text" },
  DOCS: { label: "Docs", className: "bg-teal-100 text-teal-800" },
  TEST: { label: "Tests", className: "bg-indigo-100 text-indigo-800" },
  PERF: { label: "Performance", className: "bg-amber-100 text-amber-800" },
  STYLE: { label: "Style", className: "bg-pink-100 text-pink-800" },
  OTHER: { label: "Update", className: "bg-app-surface-muted text-app-text" },
};

export const getChangelogTypeMeta = (type) =>
  CHANGELOG_TYPE_META[String(type || "").toUpperCase()] || CHANGELOG_TYPE_META.OTHER;

/**
 * Fetches the static changelog.json (regenerated by CI on every push to staging/main).
 * Bypasses cache so admins reliably see the latest entries right after a new deploy.
 */
export const fetchChangelog = async () => {
  try {
    const response = await fetch(`${CHANGELOG_URL}?t=${Date.now()}`, { cache: "no-store" });
    if (!response.ok) return [];
    const data = await response.json();
    if (!Array.isArray(data)) return [];
    return [...data].sort((a, b) => new Date(b.date) - new Date(a.date));
  } catch (error) {
    console.error("Failed to load changelog:", error);
    return [];
  }
};

export const getLastSeenChangelogId = () => localStorage.getItem(LAST_SEEN_KEY);

export const setLastSeenChangelogId = (id) => {
  if (id) localStorage.setItem(LAST_SEEN_KEY, id);
};

/**
 * Determines which entries are new since the admin last acknowledged the changelog.
 * On a brand-new browser (no stored pointer yet) we don't dump the entire history on
 * them — we just record the current latest entry as the baseline.
 */
export const getUnseenChangelogEntries = (entries, lastSeenId) => {
  if (!Array.isArray(entries) || entries.length === 0) return { unseen: [], isFirstVisit: false };
  if (!lastSeenId) return { unseen: [], isFirstVisit: true };

  const seenIndex = entries.findIndex((e) => e.id === lastSeenId);
  if (seenIndex === -1) {
    return { unseen: entries[0].id ? [entries[0]] : [], isFirstVisit: false };
  }
  return { unseen: entries.slice(0, seenIndex), isFirstVisit: false };
};
